import PropTypes from 'prop-types';
import {range} from 'lodash';
import makeConstants from 'lib/makeConstants';

export const paddingLevels = makeConstants(...range(parseInt(12, 10) + 1));

export const paddingLevelPropType = PropTypes.oneOf(Object.values(paddingLevels));
